import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const MaskedLineInView = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  return (
    <span ref={ref} className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block"
        initial={{ y: "110%" }}
        animate={inView ? { y: "0%" } : {}}
        transition={{ duration: 0.9, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const Eyebrow = ({ number, label, dark = false }) => (
  <p
    data-testid={`eyebrow-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    className={`font-display text-xs tracking-[0.3em] uppercase flex items-center gap-4 ${
      dark ? "text-ivory/60" : "text-concrete"
    }`}
  >
    <span className="text-terracotta font-medium">{number}</span>
    <span className={`h-px w-8 ${dark ? "bg-ivory/30" : "bg-anthracite/20"}`} />
    {label}
  </p>
);
